export default __webpack_public_path__ + "static/media/birth.86389c9f.gif";